import * as React from 'react'
import Head from 'next/head'
import Script from 'next/script'
import {useRouter} from 'next/router'
import {GOOGLE_ANALYTICS_ID} from 'notability-services-common-frontend'

interface PageMetadataProps {
  /** Title of the page as it would appear in the browser tab or search engine. */
  title?: string

  /** Image used to preview the content of the page. */
  previewImage?: string

  /** Description of the page as it would appear in a site preview or a search engine. */
  description?: string
}

export function PageMetadata({title, previewImage, description}: PageMetadataProps) {
  const router = useRouter()

  return (
    <>
      <Head>
        <link key="icon" rel="icon" href="/favicon.ico" />
        <meta key="viewport" property="viewport" content="width=device-width, initial-scale=1.0 viewport-fit=auto" />
        <meta key="twitter:card" property="twitter:card" content="summary_large_image" />
        <meta name="apple-itunes-app" content={`app-id=360593530, app-argument=notability://gallery${router.asPath}`} />
        {title && (
          <>
            <title key="pageTitle">{title}</title>
            <meta key="og:title" property="og:title" content={title} />
          </>
        )}
        {previewImage && (
          <>
            <meta key="og:image" property="og:image" content={previewImage} />
            <meta key="twitter:image" property="twitter:image" content={previewImage} />
          </>
        )}
        {description && <meta key="og:description" property="og:description" content={description} />}
        {<meta key="og:type" property="og:type" content={'website'} />}
      </Head>
      <Script
        id={'google-tag-manager-script'}
        src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`}
        strategy="afterInteractive"
      />
      <Script id={'gtag-config'} strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', ${JSON.stringify(GOOGLE_ANALYTICS_ID)});
        `}
      </Script>
      <Script id="facebook-pixel" strategy="afterInteractive">
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1420304259140157');
          fbq('track', 'PageView');
        `}
      </Script>
    </>
  )
}
